<template>
      <div>
      <owal-modal :show="showModal" style="width:100%; height:100%;" class="owal camera picker modal">
        <div slot="content" class="owal-detection-form-modal__panel">
          <div style="width:100%; height: 100%;" >
            <div style="margin-bottom:.5rem;">Select which cameras should receive the current detectable configuration.</div>
            <form-select-input
              label="Cameras"
              id="my-id"
              :initialValue="[]"
              :multiple="true"
              identifier="clone-select"
              :options="availableCameras.map(camera => camera[1].description)"
              @change="handleChange($event)"
            />
          </div>
          <div style="display: flex; flex-direction: row; margin-top: 3rem; justify-content: flex-end;">
            <owal-button @click="saveChanges" style="margin-right: .5rem;">Save</owal-button>
            <owal-button @click="close">Cancel</owal-button>
          </div>
        </div>
      </owal-modal>
    </div>
</template>

<script>
import OwalButton from '@/libraries/owal-ui/buttons/OwalButton'
import OwalModal from '@/libraries/owal-ui/modals/OwalModal'
import FormSelectInput from '@/libraries/owal-ui/forms-v2/FormSelectInput'
import { mapState } from 'vuex'

export default {
  name: 'ModalCloningPanel',
  components: {
    OwalButton,
    OwalModal,
    FormSelectInput,
  },
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
    availableCameras: Array,
    cloneConfigs: Object,
  },
  data () {
    return {
      editing: false,
      cloneTargets: [],
    }
  },
  methods: {
    close () {
      this.cloneTargets = []
      this.$emit('close')
    },
    saveChanges () {
      this.$emit('clone', this.cloneTargets)
      this.close()
    },
    handleChange (selected) {
      this.cloneTargets = selected
    },
  },
  computed: {
    ...mapState('dnaConfiguration', {
      camerasById: state => state.camerasById,
    }),
  },
}
</script>

<style>
  .owal.camera.picker.modal {
    display: flex;
    height: 100%;
    overflow: auto;
    padding: 5rem;
  }
  .owal-detection-form-modal__panel {
    display: flex;
    flex-direction: column;
    align-self: start;
    height: 100%;
    padding: 15px;
    background-color: #F3F4F5;
    box-shadow: 0 0 5px #555;
    border-radius: 5px;
    text-align: center;
    font-weight: bold;
    min-height: fit-content;
  }
</style>
